import { PageAreaContext } from 'global/cnr/contexts/PageAreaContext'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import SwiperProvider, { SwiperContext } from 'global/cnr/contexts/SwiperContext'
import { useSwiperContent } from 'global/cnr/contexts/useHelpers/useSwiperContent'
import { uniqueKey } from 'global/common/keys'
import { gEnums } from 'global/enums/globalEnums'
import { setStyleAndClass } from 'global/styles/formatting'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import 'swiper/css'
import { EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { _swiperMenuTypes } from './SwiperMenu'

export default function SwiperWithTabz({
  animateTransitions = true,
  applyFade = false,
  fromAppUserProfile,
  isChild = false, // if true, sets nested + touch props
  preloadDistance = 0, // how many tabs ahead/behind to preload
}) {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown } = pageArea_state ?? {}

  const _tabStyles = {
    tabsSnC: setStyleAndClass(aps_global, gEnums.projectStyles.tabs),
    tabsSnC_active: setStyleAndClass(aps_global, gEnums.projectStyles.tabs, null, null, true),
    tabsSnC_line: setStyleAndClass(aps_global, gEnums.projectStyles.tabs, null, null, false, true),
  }

  const [activeIndex, setActiveIndex] = useState(0)
  const [pageItemsLoaded, setPageItemsLoaded] = useState(_.mapValues(pageItemsShown, (pis) => pis.position === 0 ? true : false))
  const [pageItemsActivated, setPageItemsActivated] = useState(_.mapValues(pageItemsShown, (pis) => pis.position === 0 ? true : false))

  const handleIndexChange = (index) => setActiveIndex(index)

  // set the menu type
  const swiperMenuType = _swiperMenuTypes.menu

  // get the swiper contents and menu
  const { pageItemsContent, pageItemsMenu } = useSwiperContent({
    _tabStyles,
    activeIndex,
    handleIndexChange,
    pageItemsActivated,
    pageItemsLoaded,
    swiperMenuType,
  })

  const swiperRef = useRef(null)
  const menuContainerRef = useRef(null);

  // Mount active + adjacent slides
  useEffect(() => {
    if (_.isEmpty(pageItemsLoaded)) { return; }
    const nextPageItemsLoaded = _.cloneDeep(pageItemsLoaded)
    const pi = _.get(_.values(pageItemsShown), activeIndex)
    nextPageItemsLoaded[pi?.key] = true
    setPageItemsLoaded(nextPageItemsLoaded)
  }, [activeIndex, preloadDistance, _.size(pageItemsContent)])

  // Keep swiper in sync if index is controlled
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.activeIndex !== activeIndex) {
      swiperRef.current.slideTo(activeIndex, 0)
    }
  }, [activeIndex])

  const slides = useMemo(() => {
    return _.map(pageItemsContent, (child, index) => (
      <SwiperSlide key={index}>
        {child ? child : <div></div>}
      </SwiperSlide>
    ))
  }, [pageItemsContent])

  console.log('sbwt')

  return (
    <div className="swiper-with-tabs tabz">
      <div
        className='swipe-menu-container tabs tabz'
        style={_tabStyles.tabsSnC.style}
        ref={menuContainerRef}
      >
        {pageItemsMenu}
      </div>
      <div className="swiper-content-container tabbersz">
        <Swiper
          key={`swiper-${applyFade}`}
          // modules={applyFade ? [EffectFade] : []}
          // effect={applyFade ? 'fade' : 'slide'}
          // fadeEffect={{ crossFade: true }}
          speed={300}
          onSwiper={swiper => (swiperRef.current = swiper)}
          onSlideChange={swiper => handleIndexChange?.(swiper.activeIndex)}
          nested={isChild}
          slidesPerView={1}
          spaceBetween={20}
          threshold={10}
          resistance
          touchMoveStopPropagation={isChild ? false : undefined}
          touchStartPreventDefault={isChild ? false : undefined}
        >
          {slides}
        </Swiper>
      </div>
    </div>
  )
}

export const SwiperWithTabsWithProvider = (props) => {
  const { keyy, swipeContentType, swipeItems, uiElems, view, fn_getContent, fromAppUserProfile, layoutType, isAdminHidden } = props
  const uk = uniqueKey('swp', keyy)
  return <SwiperProvider
    fn_getContent={fn_getContent}
    isAdminHidden={isAdminHidden}
    keyy={uk}
    layoutType={layoutType}
    swipeContentType={swipeContentType}
    swipeItems={swipeItems}
    uiElems={uiElems}
    view={view}
  >
    {/* <SwipperAll /> */}
    <SwiperWithTabz applyFade={true} />
  </SwiperProvider>
}